<template>
  <footer class="relative z-10 bg-slate-900/70 backdrop-blur-sm py-8 mt-12">
    <div class="container mx-auto px-6 md:px-10">
      <div class="flex flex-col md:flex-row justify-between items-center gap-6">
        <div class="flex items-center gap-3">
          <img src="/ducksImages/duckIcon.webp" class="w-8 h-8" alt="Duck Logo" />
          <h3 class="font-bold text-lg text-white">DuckNSeek</h3>
        </div>
        <div class="flex gap-6">
          <a href="#" class="text-gray-300 hover:text-white transition-colors">About</a>
          <a href="#" class="text-gray-300 hover:text-white transition-colors">FAQ</a>
          <a href="#" class="text-gray-300 hover:text-white transition-colors">Contact</a>
          <a href="#" class="text-gray-300 hover:text-white transition-colors">Privacy</a>
        </div>
        <div class="flex gap-4">
          <v-btn icon variant="text" color="white">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon variant="text" color="white">
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
          <v-btn icon variant="text" color="white">
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="text-center mt-8 text-gray-400 text-sm">
        &copy; {{ new Date().getFullYear() }} DuckNSeek. All rights reserved.
      </div>
      <a href="https://genienweb.com" target="_blank" rel="noopener noreferrer" class="mt-3 flex items-center justify-center gap-2 text-gray-300 text-sm hover:text-white transition-colors">
        <img src="/genienweb.webp" class="h-6 w-auto" alt="Genienweb" />
        <span>This website was designed by Genienweb</span>
      </a>
    </div>
  </footer>
</template>
